import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class TiktokOrderProvider extends HttpRequest {
  shipPackage (payload) {
    this.setHeader(getAuthToken())
    return this.post('/tiktok/orders/ship', payload)
  }

  getDocument (payload) {
    this.setHeader(getAuthToken())
    return this.post('/tiktok/orders/get-document', payload)
  }
}
